export const SearchOverviewTexts = {
    yoy: "common.yoy",
    mom: "common.mom",
    yoyChange: "analysis.source.search.overview.yoyChange",
    momChange: "global.change.mom",
    distributionBranded: "analysis.source.search.overview.widgets.branded",
    distributionNonBranded: "analysis.source.search.overview.widgets.nonbranded",
    keywords: "common.keywords",
    overview: "analysis.overview.title",
    performance: "analysis.performance.title",
    seeMore: "analysis.source.search.overview.seeMore",
    seeAll: "analysis.source.search.overview.seeAll",
    organicVsPaid: "analysis.source.search.overview.organic.paid",
    brandedVsNonBranded: "analysis.source.search.overview.branded.nonbranded",
    brandedTrafficTitle: "analysis.source.search.overview.brandednonbranded",
    brandedTrafficTooltip: "analysis.source.search.overview.widgets.brandednonbranded.tooltip",
    searchTrafficTitle: "analysis.source.search.overview.filters.search",
    searchTrafficTooltip: "analysis.source.search.overview.widgets.search.tooltip",
    rankPositionTitle: "analysis.source.search.overview.widgets.rankposition",
    rankPositionTooltip: "analysis.source.search.overview.widgets.rankposition.tooltip",
    notSupportedData: "analysis.source.search.overview.notsupported",
    tryRecentPeriod: "analysis.source.search.overview.tryrecentperiod",
};
